import type { ShopifyConversionsSummary } from '@discovr/types';
import { shopifyCopy } from '@discovr/features/copy';

/** The badge and note for a store that can't be used right now, by the reason
 *  the BE knows; the generic unreachable wording when it doesn't. */
export function unavailableStoreCopy(
  summary: Pick<ShopifyConversionsSummary, 'store_state' | 'store_lifecycle'>,
): { badge: string; note: string } | null {
  if (summary.store_state !== 'store_unavailable') return null;
  const lifecycle = summary.store_lifecycle;
  if (lifecycle === 'uninstalling' || lifecycle === 'access_lost') {
    return shopifyCopy.report.lifecycle[lifecycle];
  }
  return {
    badge: shopifyCopy.state.store_unavailable.badge,
    note: shopifyCopy.state.store_unavailable.report,
  };
}

/** Deletion after an uninstall is under way: the figures may be part deleted,
 *  so none are shown. */
export function isDeletingStoreData(
  summary: Pick<ShopifyConversionsSummary, 'store_state' | 'store_lifecycle'>,
): boolean {
  return summary.store_state === 'store_unavailable' && summary.store_lifecycle === 'deleting';
}
